import { createReducer } from "../../../_common/common";
import {
  SET_CERT_APPLICATION_STATUS,
  SET_ACE_CERT_APPLICATION_STATUS,
} from "../actions/constants";

const initialState = {
  status: null,
  aceStatus: null,
};
export const certificateApplication = createReducer(initialState, {
  [SET_CERT_APPLICATION_STATUS]: (state, payload) => {
    return {
      ...state,
      status: payload.data[0],
    };
  },
  [SET_ACE_CERT_APPLICATION_STATUS]: (state, payload) => {
    return {
      ...state,
      aceStatus: payload.data,
    };
  },
});
